import React from 'react';
import {
  GraduationCap,
  Volleyball,
  Music,
  Palette,
  Sparkles,
  MapPin,
} from 'lucide-react';
import { normalizeActivityKey } from '../utils/carpoolUi';

/** One Lucide icon per activity category — keep in sync with CreateCarpool / API. */
const MAP = {
  school: GraduationCap,
  sport: Volleyball,
  music: Music,
  art: Palette,
  dance: Sparkles,
  other: MapPin,
};

/**
 * Lucide icon for carpool activity type (same metaphor everywhere: lists, details, wizard).
 */
function ActivityIcon({ activity, size = 22, className = '', strokeWidth = 2 }) {
  const key = normalizeActivityKey(activity);
  const Icon = MAP[key] || MAP.other;
  return <Icon size={size} strokeWidth={strokeWidth} className={className} aria-hidden />;
}

/**
 * Rounded badge wrapper — matches invitations / list cards.
 */
export function ActivityIconBadge({ activity, size = 22, className = '' }) {
  return (
    <span className={`activity-icon-badge${className ? ` ${className}` : ''}`} aria-hidden>
      <ActivityIcon activity={activity} size={size} className="activity-icon-badge__svg" />
    </span>
  );
}

export default ActivityIcon;
